import toUpper from 'lodash/toUpper'
import { setSessionStorage } from '../local-preferences/index'
import { FACEBOOK_PIXEL_TEST_CODE_KEY } from '../event-tracking/index'

export default function init (state) {
  const { resolver } = state
  const fbPixelTestCode = toUpper(resolver.getIn(
    ['query', 'facebook_pixel_test_code'],
  ) || '')

  if (fbPixelTestCode) {
    setSessionStorage(FACEBOOK_PIXEL_TEST_CODE_KEY, fbPixelTestCode)
  }
}
